import { Center } from '@mantine/core';
import { IconCar } from '@tabler/icons-react';
import { useSlikaVozila } from './useSlikaVozila';
import { barve } from '../tema';

/** Sličica vozila (razmerje 4 : 3) ali ikona avtomobila, če slike ni. */
export function SlikaVozila({
  voziloId,
  slikaId,
  sirina,
}: {
  voziloId: number;
  slikaId?: number | null;
  sirina: number | string;
}) {
  const url = useSlikaVozila(voziloId, slikaId ?? undefined);
  return (
    <Center
      w={sirina}
      style={{ aspectRatio: '4 / 3', background: barve.izbrano, borderRadius: 8, overflow: 'hidden', flexShrink: 0 }}
    >
      {url ? (
        <img src={url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
      ) : (
        <IconCar size={28} stroke={1.3} color={barve.besediloSekundarno} />
      )}
    </Center>
  );
}
